import { render, staticRenderFns } from "./ComponentRedeem.vue?vue&type=template&id=13204c02"
import script from "./ComponentRedeem.vue?vue&type=script&lang=js"
export * from "./ComponentRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports